import { render, staticRenderFns } from "./edit-budget.vue?vue&type=template&id=1492567c&scoped=true"
import script from "./edit-budget.vue?vue&type=script&lang=js"
export * from "./edit-budget.vue?vue&type=script&lang=js"
import style0 from "./edit-budget.vue?vue&type=style&index=0&id=1492567c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492567c",
  null
  
)

export default component.exports